import { Divider, Typography } from "@mui/material";

function TopHeadingDividerComponent({
  primary,
  secondary,
  divider = true,
  primaryFontSize = "20px",
  primaryLineHeight = "24.2px",
  secondaryBottomPadding = "22px",
  primaryBottomPadding = "0px",
  primaryTopPadding = "0px",
}) {
  return (
    <>
      {" "}
      <Typography
        variant="subtitle1"
        sx={{
          fontSize: primaryFontSize,
          fontWeight: "600",
          lineHeight: primaryLineHeight,
          pb: primaryBottomPadding,
          pt: primaryTopPadding,
        }}
      >
        {primary}
      </Typography>{" "}
      {divider && (
        <Divider
          sx={{
            height: "1px",
            bgcolor: "#EBEBEB",
            border: "none",
            mx: "-20px",
            my: "16px",
          }}
        />
      )}
      <Typography
        variant="body2"
        sx={{
          fontSize: "18px",
          fontWeight: "400",
          lineHeight: "21.78px",
          pb: secondaryBottomPadding,
        }}
      >
        {secondary}
      </Typography>
    </>
  );
}

export default TopHeadingDividerComponent;
